import { Component, inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMap } from '@fortawesome/free-solid-svg-icons';
import { ShippingTargetDialogState } from '../shipping-target-dialog.state';

/** Position „Station auswählen": gewählte PickPoint-Station + Kartenauswahl. */
@Component({
  standalone: true,
  selector: 'hawk-shipping-station-position',
  imports: [FontAwesomeModule],
  template: `
    <div class="flex flex-row gap-2 items-center flex-wrap">
      <div class="flex-1 flex items-center gap-2 min-h-[2.25rem] min-w-0">
        @if (state.selectedStation(); as station) {
          <span class="bm-badge bm-badge-neutral">PP-{{ station.pp_id }}</span>
          <span class="truncate">{{ station.name }}</span>
          @if (station.address_zip || station.address_city) {
            <span class="opacity-60 text-sm whitespace-nowrap">
              {{ station.address_zip }} {{ station.address_city }}
            </span>
          }
        } @else {
          <span class="opacity-60 italic">Noch keine Station gewählt</span>
        }
      </div>
      <button
        class="bm-btn bm-btn-sm"
        type="button"
        [disabled]="!state.canOpenMap() || state.readOnly()"
        [title]="state.canOpenMap() ? 'Auf Karte auswählen' : 'Kein Auftragsort mit Koordinaten verfügbar'"
        (click)="state.showMapPicker.set(true)"
      >
        <fa-icon [icon]="iconMap" class="mr-1" />
        Auf Karte wählen
      </button>
    </div>
  `,
})
export class ShippingStationPositionComponent {
  protected state = inject(ShippingTargetDialogState);
  protected iconMap = faMap;
}
